import CityPageTemplate from "../city-template/CityPageTemplate";
import { santaAnaConfig } from "./data";

export default function SantaAnaPage() {
  return <CityPageTemplate config={santaAnaConfig} />;
}